import { get, post, put } from './axios.js'

/**
 * 첨부파일 조회 - /fileList
 * @param {object} params
 * @property {string} params.file_seq_grp
 * @returns
 */
export async function fileList(params = {}) {
  try {
    const result = await post('/fileList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 파일 임시저장 - /ref_data
 * @param {FormData} params
 * @property {File} params.file
 * @returns
 */
export async function tempUpload(params = {}) {
  try {
    const result = await put('/ref_data', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 임시파일 -> 실제 저장 - /ref_data
 * @param {object} params
 * @property {string} params.up_path
 * @property {array} params.fileListVo
 * @returns
 */
export async function fileUpload(params = {}) {
  try {
    const result = await post('/ref_data', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 임시파일 -> 실제 저장 - /ref_data/{file_seq}
 * @param {String} file_seq
 * @returns
 */
export async function fileDownload(file_seq) {
  try {
    const result = await get(`/ref_data/${file_seq}`,{responseType: "blob"})
    return result
  } catch(e) {
    throw new Error(e)
  }
}